import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');

export function dateFormat(date) {
  if(!date) { return ''; }

  return moment(date).format('YYYY/MM/DD');
}

export function datetimeFormat(datetime) {
  if(!datetime) { return ''; }

  return moment(datetime).format('YYYY年MM月DD日 HH:mm');
}

export function dateFormatHyphen(date) {
  if(!date) { return ''; }

  return moment(date).format('YYYY-MM-DD');
}
